/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
import * as t from "react";
import { footerColumns as l } from "../utils/index.mjs";
import { tableKeyboardNavigationTools as m } from "@progress/kendo-react-data-tools";
import { FooterCell as i } from "./FooterCell.mjs";
const f = (e) => /* @__PURE__ */ t.createElement("tr", { className: "k-table-row", role: "row", "aria-rowindex": e.ariaRowIndex }, l(e.columns).map((a, o) => {
  const r = m.generateNavigatableId(
    `${o}-footercell`,
    e.idPrefix,
    "nodata"
  );
  return /* @__PURE__ */ t.createElement(i, { key: r, column: a, id: r, index: o, cells: e.cells });
}));
export {
  f as FooterRow
};
